import { getLocale } from "../translations/selector";

export const getStaticPageRedirectsByLocale = state =>
  state.staticPageRedirects.byLocale;

export const getStaticPageRedirectsLoading = state =>
  state.staticPageRedirects.loading;

export const getStaticPageRedirectsForLocale = (state, locale) =>
  getStaticPageRedirectsByLocale(state)[locale];

export const getStaticPageRedirectsForCurrentLocale = state =>
  getStaticPageRedirectsForLocale(state, getLocale(state));
